import { yupResolver } from "@hookform/resolvers/yup";
import defaultAxios, { AxiosError } from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import useResetPassword from "../../../services/mutations/useResetPassword";
import {
    ResetPasswordFormValues,
    resetPasswordSchema,
} from "../resetPasswordSchema";

const useResetPasswordForm = () => {
    const history = useHistory();
    const [showPasswordBaru, setShowPasswordBaru] = useState(false);
    const [showPasswordBaruUlang, setShowPasswordBaruUlang] = useState(false);
    const resetPasswordMutation = useResetPassword();

    const form = useForm<ResetPasswordFormValues>({
        resolver: yupResolver(resetPasswordSchema),
        defaultValues: {
            passwordBaru: "",
            passwordBaruUlang: "",
        },
    });

    const queryToken = new URLSearchParams(window.location.search).get("token");

    const handleErrorResponse = (error: unknown) => {
        if (!defaultAxios.isAxiosError(error)) return;

        const serverError = error as AxiosError<any>;
        if (!serverError.response) return;

        const fieldError = serverError.response.data;
        if (fieldError?.errors) {
            Object.keys(fieldError.errors).forEach((key) => {
                const errorMessage = fieldError.errors[key];
                form.setError(key as keyof ResetPasswordFormValues, {
                    type: "manual",
                    message: errorMessage[0],
                });
            });
            return;
        }

        Swal.fire({
            title: `${fieldError.message}`,
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            customClass: {
                container: "my-swal",
            },
        });
    };

    const onSubmit = (values: ResetPasswordFormValues) => {
        const formData = new FormData();
        formData.append("token", queryToken ?? "nothing");
        formData.append("password", values.passwordBaru);

        resetPasswordMutation.mutate(formData, {
            onSuccess: (data) => {
                Swal.fire({
                    title: `${data.message}`,
                    position: "top-end",
                    showConfirmButton: false,
                    icon: data.code === 200 ? "success" : "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
                if (data.code === 200) {
                    history.push("/");
                }
            },
            onError: (error) => {
                handleErrorResponse(error);
                console.error(error);
            },
        });
    };

    return {
        form,
        isButtonLoading: resetPasswordMutation.isLoading,
        onSubmit,
        showPasswordBaru,
        showPasswordBaruUlang,
        toggleShowPasswordBaru: () => {
            setShowPasswordBaru((previousState) => !previousState);
        },
        toggleShowPasswordBaruUlang: () => {
            setShowPasswordBaruUlang((previousState) => !previousState);
        },
    };
};

export type ResetPasswordFormModel = ReturnType<typeof useResetPasswordForm>;

export default useResetPasswordForm;
